import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import s from './s.module.less';
import PPAOnboardingHeader from 'components/PPAOnboardingHeader';
import AIChat from 'components/AIChat';
import SetGolive from 'pages/PPAOnboardingFinishPage/components/SetGolive';
import { PATH } from 'constants/path';
import { EAIChatPageId } from 'types/ai';
import { saveStep, getStep } from 'api/ppaOnboarding';
import { EInvitedProviderStep } from '../steps';

// https://www.figma.com/design/aGY2cI5da2oGElG6GEd0Wo/Group-Practice?node-id=4914-8964&m=dev
// Shown after the invited provider submits the initial onboarding profile.
export default function InvitedProviderGoLivePage() {
    const navigate = useNavigate();

    useEffect(() => {
        let cancelled = false;
        (async () => {
            const res = await getStep();
            const saved = res?.data?.data?.currentStep;
            if (cancelled) return;
            if (saved === EInvitedProviderStep.COMPLETED) {
                navigate(PATH.DASHBOARD, { replace: true });
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [navigate]);

    const handleGoToAdvancedSetup = async () => {
        const res = await saveStep(EInvitedProviderStep.ADVANCE_SETTING);
        if (res.error) {
            return;
        }
        navigate(PATH.INVITED_PROVIDER_ADVANCED_SETTINGS);
    };

    return (
        <div className={s.wrap}>
            <PPAOnboardingHeader showLogout />
            <div className={s.content}>
                <div className={s.contentWrap}>
                    <div className={s.contentIn}>
                        <SetGolive onGoToAdvancedSetup={handleGoToAdvancedSetup} enableGrowthGoal={false} />
                    </div>
                    <div className={s.chatWrap}>
                        <AIChat
                            pageId={EAIChatPageId.INVITED_PROVIDER_GO_LIVE}
                            defaultShow={false}
                            buttonStyle={{ bottom: '45px' }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
